import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController } from 'ionic-angular';
import { WpApiPosts, WpApiMedia } from 'wp-api-angular';
import { Observable } from 'rxjs';
import { InAppBrowser, InAppBrowserOptions } from '@ionic-native/in-app-browser';

@IonicPage()
@Component({
  selector: 'page-home',
  templateUrl: 'home.html',
})
export class HomePage {
  posts = [];
  options: any;
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private wap: WpApiPosts,
    private wam: WpApiMedia,
    private loadingCtrl: LoadingController,
    private iab: InAppBrowser,
    ) {
      this.options = 'europa';
      this.loadPosts();
  }

  loadPosts(){
    let loading = this.loadingCtrl.create({
      dismissOnPageChange: true,
    });
    loading.present();

    this.wap.getList().map(response => response.json()).subscribe(data => {
      this.posts = data;
      for(let post of data){
        post.media_url = this.getMedia(post.featured_media);
      };
      loading.dismiss();
    })
  }

  openPost(post){
    const options: InAppBrowserOptions = {
      zoom: 'no'
    };
    const browser = this.iab.create(post.link, '_blank', options);
  }

  getMedia(id): Observable<string>{
    return this.wam.get(id).map(res => res.json()).map(data => {
      return data['source_url'];
    })
  }

}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts